// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"5df8148d","787":"fa3c4679"}[chunkId] + ".chunk.js";
};